/**
 * Shared password-strength validator. A password is valid when it is at least
 * 8 characters long and contains at least one letter, one digit, and one
 * non-alphanumeric special character. Centralised here so registration,
 * change-password, and reset-password flows enforce the exact same rule.
 */
export const validatePassword = (password) => {
  if (typeof password !== 'string' || password.length < 8) {
    return false;
  }
  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[^a-zA-Z0-9]/.test(password);
  return hasLetter && hasNumber && hasSpecial;
};
